import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createLoadableValidator } from "../loadables/SWBaseLoadable";
/** @public */ /** @internal */ export const rootLoadableVersions = {};
/** @internal */ export const rootLoadableMigrations = defineMigrations({});
/** @public */ export function isLoadable(record) {
    if (!record) return false;
    return record.typeName === "loadable";
}
export function createLoadableId(type, id) {
    return `loadable:${type}:${id}`;
}
/** @public */ export function isLoadableId(id) {
    if (!id) return false;
    return id.startsWith("loadable:");
}
/** @internal */ export function createLoadableRecordType(loadables) {
    return createRecordType("loadable", {
        migrations: undefined,
        scope: "presence",
        validator: T.model("loadable", T.union("type", mapObjectMapValues(loadables, (type, { props, meta })=>createLoadableValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {},
            status: {
                status: "not-loaded"
            }
        }));
}
